import styles from './Logo.module.css';

type LogoProps = {
  compact?: boolean;
};

export function Logo({ compact }: LogoProps) {
  return (
    <div className={compact ? styles.wrapCompact : styles.wrap}>
      <img src="/logo.svg" alt="" width={40} height={40} className={styles.mark} />
      {!compact && (
        <div>
          <div className={styles.title}>Marketing Hub</div>
          <div className={styles.tagline}>Eén cockpit voor outreach</div>
        </div>
      )}
    </div>
  );
}
